import React from 'react';
import ExecutivePresence from '../components/landingPages/ExecutivePresence';
import KnowYourExecutive from '../components/landingPages/KnowYourExecutive';
import CardList from '../components/landingPages/CardList';
import Testenomial from './LandingPage/Testenomial';
import PricingPlan from './LandingPage/PricePlan';
import Tedx from './LandingPage/Tedx';
import AfterTedx from './AfterTedx';
import BbelowFooter from './LandingPage/BbelowFooter';
import InitiateAsmt from './LandingPage/InitiateAsmt';
import GetReview from '../components/landingPages/GetReview';

const HomePage = () => {
  return (<>
    <ExecutivePresence />
    <KnowYourExecutive />
    <GetReview />
    <Tedx />
    <InitiateAsmt />
    <AfterTedx /> 
    <CardList />
    <Testenomial />
    <PricingPlan />
    <BbelowFooter />

  </>
  );
};

export default HomePage;
